module.exports = __webpack_public_path__ + "img/boy_white_earphones_hoodie.12391dd2.png";